import React, { useState, useContext, useEffect } from 'react';
import CidadesContext from '../../../context/cidades.context';
import UsuarioContext from '../../../context/usuario.context';
import FirebaseContext from '../../../context/firebase.context';
import { notify } from '../../../functions/notifications';
import { fetchCitiesByUf } from '../../../services/apis';
import { EnviarNotificacoes, EnviarNotificacoesAvulsa } from '../../../services/apiWhats';
import Firebase from '../../../services/firebase';
import './notificarUsuarios.scss';
import { FormataTelefone, NotificarNaPlataforma } from '../../../functions/helper';

function NotificarUsuarios() {
  const { listUsuarios } = useContext(FirebaseContext);
  const { listUf } = useContext(CidadesContext);
  const { usuario: { uid }, usuario: usuarioLogado } = useContext(UsuarioContext);
  const [listCidade, setListCidade] = useState([]);
  const [disabledButton, setDisabledButton] = useState(true);
  const [uidUser, setUidUser] = useState('');
  const [sendEnabled, setSendEnabled] = useState(false);
  const [initialValue, setInItialValue] = useState(true);
  const [headerNotificacoes, setHeaderNotificacoes] = useState({
    como: 'todos',
    estado: '-- SELECIONE A UF --',
    cidade: '-- SELECIONE A UF --',
    tipo: 'Aplicador de Defensivos',
    usuario: '-- SELECIONE O USUÁRIO --',
    numero: '-- INFORME O NUMERO --',
    mensagem: '',
  });
  const {
    como, estado, usuario, cidade, numero, mensagem, tipo,
  } = headerNotificacoes;
  const { nome: nomeAdmin } = usuarioLogado;

  function enviarComFiltro() {
    Firebase.firestore()
      .collection('users')
      .get()
      .then((result) => {
        const usuarios = result.docs.map((user) => user.data());
        usuarios.forEach((user) => {
          const {
            celular,
            cidade: cidadeLoop,
            estado: estadoLoop,
            tipoDeCadastro,
            nome, uid: uidLoop,
          } = user;

          switch (como) {
            case 'todos':
              if (uid !== uidLoop) {
                EnviarNotificacoes(
                  {
                    celular,
                    nome,
                    mensagem,
                  },
                );
                NotificarNaPlataforma({ uidEnviar: uidLoop, mensagemEnviar: mensagem });
              }
              break;
            case 'cidade':
              if (uid !== uidLoop && (cidade === cidadeLoop && estado === estadoLoop)) {
                EnviarNotificacoes(
                  {
                    celular,
                    nome,
                    mensagem,
                  },
                );
                NotificarNaPlataforma({ uidEnviar: uidLoop, mensagemEnviar: mensagem });
              }
              break;
            case 'estado':
              if (uid !== uidLoop && estado === estadoLoop) {
                EnviarNotificacoes(
                  {
                    celular,
                    nome,
                    mensagem,
                  },
                );
                NotificarNaPlataforma({ uidEnviar: uidLoop, mensagemEnviar: mensagem });
              }
              break;
            case 'cultura-cidade':
              if (
                uid !== uidLoop
                && (cidade === cidadeLoop && estado === estadoLoop)
                && (tipoDeCadastro === tipo)
              ) {
                EnviarNotificacoes(
                  {
                    celular,
                    nome,
                    mensagem,
                  },
                );
                NotificarNaPlataforma({ uidEnviar: uidLoop, mensagemEnviar: mensagem });
              }
              break;
            case 'cultura-estado':
              if (
                uid !== uidLoop
                && estado === estadoLoop
                && tipoDeCadastro === tipo
              ) {
                EnviarNotificacoes(
                  {
                    celular,
                    nome,
                    mensagem,
                  },
                );
                NotificarNaPlataforma({ uidEnviar: uidLoop, mensagemEnviar: mensagem });
              }
              break;
            case 'cultura':
              if (
                uid !== uidLoop
                && tipoDeCadastro === tipo
              ) {
                EnviarNotificacoes(
                  {
                    celular,
                    nome,
                    mensagem,
                  },
                );
                NotificarNaPlataforma({ uidEnviar: uidLoop, mensagemEnviar: mensagem });
              }
              break;
            case 'um':
              if (uid !== uidLoop && uidLoop === uidUser) {
                EnviarNotificacoes(
                  {
                    celular,
                    nome,
                    mensagem,
                  },
                );
                NotificarNaPlataforma({ uidEnviar: uidLoop, mensagemEnviar: mensagem });
              }
              break;
            default:
              break;
          }
        });
        const textoNotificacao = como === 'um'
          ? 'Sua notificação foi enviada com sucesso'
          : 'Suas notificações foram enviadas com sucesso';
        setHeaderNotificacoes({
          como: 'todos',
          estado: '-- SELECIONE A UF --',
          cidade: '-- SELECIONE A UF --',
          tipo: 'Aplicador de Defensivos',
          usuario: '-- SELECIONE O USUÁRIO --',
          numero: '-- INFORME O NUMERO --',
          mensagem: '',
        }, NotificarNaPlataforma(
          {
            uidEnviar: uid,
            mensagemEnviar: `${nomeAdmin.split(' ')[0]}, ${textoNotificacao}`,
          },
        ),
        notify('success', textoNotificacao));
      });
  }

  function sendNotifications() {
    switch (como) {
      case 'numero':
        if (sendEnabled) {
          EnviarNotificacoesAvulsa({ numero, mensagem }, setHeaderNotificacoes({
            como: 'todos',
            estado: '-- SELECIONE A UF --',
            cidade: '-- SELECIONE A UF --',
            tipo: 'Aplicador de Defensivos',
            usuario: '-- SELECIONE O USUÁRIO --',
            numero: '-- INFORME O NUMERO --',
            mensagem: '',
          }, notify('success', 'Sua notificação foi enviada com sucesso')));
        }
        break;
      default:
        enviarComFiltro();
        break;
    }
  }

  useEffect(() => {
    if (estado !== '-- SELECIONE A UF --') {
      fetchCitiesByUf(estado).then((data) => {
        data.sort((a, b) => a.nome.localeCompare(b.nome));
        setListCidade([...data]);
      });
    } else {
      setListCidade([], setListCidade([]), setHeaderNotificacoes((prevState) => ({
        ...prevState, cidade: '-- SELECIONE A UF --',
      })));
    }
  }, [headerNotificacoes.cidade, headerNotificacoes.estado, headerNotificacoes.tipo]);

  useEffect(() => {
    if (uidUser !== '-- SELECIONE O USUÁRIO --') {
      const selectedUser = listUsuarios.find((user) => user.uid === uidUser);
      setHeaderNotificacoes((prevState) => ({
        ...prevState, usuario: selectedUser,
      }));
    } else {
      setHeaderNotificacoes((prevState) => ({
        ...prevState, usuario: '-- SELECIONE O USUÁRIO --',
      }));
    }
  }, [uidUser]);

  useEffect(() => {
    setInItialValue(false);
    const userValid = !!usuario?.nome;
    const cidadeIsValid = cidade !== '-- SELECIONE A UF --';
    const estadoIsValid = estado !== '-- SELECIONE A UF --';
    const numeroIsValid = numero !== '-- INFORME O NUMERO --' && numero.trim().length >= 13;
    switch (como) {
      case 'um':
        setDisabledButton((!userValid), setSendEnabled(!userValid), setSendEnabled(true));
        break;
      case 'todos':
        setDisabledButton(false, setSendEnabled(true));
        break;
      case 'cultura':
        setDisabledButton(false, setSendEnabled(true), setSendEnabled(true));
        setHeaderNotificacoes((prevState) => ({
          ...prevState, estado: '-- SELECIONE A UF --',
        }));
        setUidUser('');
        break;
      case 'cultura-estado':
        if (estadoIsValid) {
          setDisabledButton(false, setSendEnabled(true));
          setUidUser('');
        } else {
          setDisabledButton(true, setSendEnabled(false));
        }
        break;
      case 'estado':
        if (estadoIsValid) {
          setDisabledButton(false, setSendEnabled(true));
          setUidUser('');
        } else {
          setDisabledButton(true, setSendEnabled(false));
        }
        break;
      case 'cultura-cidade':
        if (estadoIsValid && cidadeIsValid) {
          setDisabledButton(false, setSendEnabled(true));
        } else {
          setDisabledButton(true, setSendEnabled(false));
        }
        break;
      case 'cidade':
        if (estadoIsValid && cidadeIsValid) {
          setDisabledButton(false, setSendEnabled(true));
        } else {
          setDisabledButton(true, setSendEnabled(false));
        }
        break;
      case 'numero':
        if (numeroIsValid) {
          setDisabledButton(false, setSendEnabled(true));
        } else {
          setDisabledButton(true, setSendEnabled(false));
        }
        break;
      default:
        setDisabledButton(true, setSendEnabled(false));
        break;
    }
  }, [headerNotificacoes.tipo, headerNotificacoes.como, usuario, estado, cidade, numero]);

  return (
    <div id="notificar-usuario">
      <div className="notificar-header">
        <label id="label-como" className="como">
          <span>
            Como deseja notificar?
          </span>
          <select
            className="form-control"
            name="como"
            id="como"
            onChange={(e) => {
              setHeaderNotificacoes((prevState) => ({
                ...prevState, como: e.target.value,
              }));
            }}
          >
            <option selected={initialValue} value="todos">Todos os usuários</option>
            <option value="um">Apenas um usuário</option>
            <option value="cultura">Todos por cultura</option>
            <option value="cultura-estado">Todos por cultura/Estado</option>
            <option value="cultura-cidade">Todos por cultura/Cidade</option>
            <option value="cidade">Todos por cidade</option>
            <option value="estado">Todos por estado</option>
            <option value="numero">Informar Número</option>
          </select>
        </label>
        {como === 'um'
          && (
          <label id="label-usuario" className="usuario">
            <span>
              Selecione o usuário.
            </span>
            <select
              className="form-control"
              name="usuario"
              id="usuario"
              onChange={(e) => setUidUser(e.target.value)}
            >
              <option
                selected
                value="-- SELECIONE O USUÁRIO --"
              >
                -- SELECIONE O USUÁRIO --
              </option>
              {listUsuarios.map((user) => (
                <option
                  value={user.uid}
                >
                  {`${user.nome}, ${user.cidade}-${user.estado} | ${user.celular}`}
                </option>
              ))}
            </select>
          </label>
          )}
        {(como === 'cultura' || como === 'cultura-estado' || como === 'cultura-cidade')
          && (
          <label id="label-tipo" className="tipo">
            <span>
              Informe o tipo de cadastro.
            </span>
            <select
              className="form-control"
              name="tipo"
              id="tipo"
              onChange={(e) => setHeaderNotificacoes((prevState) => ({
                ...prevState, tipo: e.target.value,
              }))}
            >
              <option selected value="Apicultura (Colmeias)">Apicultura (Colmeias)</option>
              <option value="Aplicador de Defensivos">Aplicador de Defensivos</option>
              <option value="Bicho-da-seda (Sericicultura)">Bicho-da-seda (Sericicultura)</option>
              <option value="Cultura Suscetível / Certificada">Cultura Suscetível / Certificada</option>
            </select>
          </label>
          )}
        {como === 'numero'
          && (
          <label id="label-numero" className="numero">
            <span>
              Informe o número do WhatsApp.
            </span>
            <input
              onChange={(e) => {
                setHeaderNotificacoes((prevState) => ({
                  ...prevState, numero: FormataTelefone(e.target.value),
                }));
              }}
              type="text"
              required
              id="numero"
              name="numero"
              value={headerNotificacoes.numero}
              placeholder="Informa o WhatsApp"
            />
          </label>
          )}
        {(como === 'estado' || como === 'cidade' || como === 'cultura-estado' || como === 'cultura-cidade')
          && (
          <label id="label-estado" className="estado">
            <span>
              Informe o Estado.
            </span>
            <select
              className="form-control"
              id="estado-estado"
              name="estado"
              onChange={(e) => {
                setListCidade([], setHeaderNotificacoes((prevState) => ({
                  ...prevState, estado: e.target.value, cidade: '-- SELECIONE A UF --',
                })));
              }}
            >
              <option
                selected
                value="-- SELECIONE A UF --"
              >
                -- SELECIONE A UF --
              </option>
              {listUf.map((a) => <option estado={a.nome} value={a.sigla}>{a.nome}</option>)}
            </select>
          </label>
          )}
        {(como === 'cidade' || como === 'cultura-cidade')
          && (
            <label id="label-cidade" className="cidade">
              <span>
                Informe a cidade.
              </span>
              <select
                className="form-control"
                id="cidade-notify"
                name="cidade"
                onChange={(e) => setHeaderNotificacoes((prevState) => ({
                  ...prevState, cidade: e.target.value,
                }))}
              >
                <option selected value="-- SELECIONE A UF --">
                  -- SELECIONE A UF --
                </option>
                {listCidade.map((a) => (
                  <option value={a.nome}>
                    {a.nome}
                  </option>
                ))}
              </select>
            </label>
          )}
      </div>
      <div className="notificar-body">
        <div className="separator">
          <span>
            Digite sua mensagem
          </span>
        </div>
        <label htmlFor="observacoes">
          <textarea
            placeholder="Digite a mensagem aqui..."
            value={headerNotificacoes.mensagem}
            name="observacoes"
            onChange={(e) => setHeaderNotificacoes((prevState) => ({
              ...prevState, mensagem: e.target.value,
            }))}
            disabled={false}
          />
        </label>
        <button
          onClick={() => {
            if (mensagem.trim().length > 0) {
              sendNotifications();
            } else {
              notify('warning', 'Ops!!! digite uma mensagem');
            }
          }}
          type="button"
          disabled={disabledButton}
          className="btn btn-dark btn-sm"
        >
          Enviar Mensagem
        </button>
      </div>
    </div>
  );
}

export default NotificarUsuarios;
